import React, { useState, useMemo, useEffect } from 'react';
import './WorkIndex2.css';
import { WORKS, isVideo } from './worksData';
import { loadDisplayWorks } from './store';
import WorkVisual from './WorkVisual';

const STRIP_SIZE = 5;

// Tire 5 images au hasard parmi celles affichées (sans les vidéos,
// trop lourdes pour la bande qui s'ouvre au survol)
const randomStrip = (pool) => {
  const shuffled = [...pool].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, STRIP_SIZE);
};

export default function WorkIndex2({ onOpenWork }) {
  const [hoveredIdx, setHoveredIdx] = useState(null);
  const [items, setItems] = useState(WORKS);

  useEffect(() => {
    loadDisplayWorks().then((liste) => {
      if (liste.length > 0) setItems(liste);
    });
  }, []);

  // Une sélection aléatoire par ligne, refaite si la liste change
  const strips = useMemo(() => {
    const pool = items.map((w) => w.image).filter((src) => !isVideo(src));
    return items.map(() => randomStrip(pool));
  }, [items]);

  return (
    <div className="work-index2-container">
      <div className="work-index2-scroll">
        <div className="work-index2-list">
        {items.map((item, idx) => (
          <a
            key={idx}
            href={item.link}
            className={
              "work-index2-row" +
              (hoveredIdx !== null && hoveredIdx !== idx ? " work-index2-row--dim" : "")
            }
            style={{ '--i': idx }}
            onMouseEnter={() => setHoveredIdx(idx)}
            onMouseLeave={() => setHoveredIdx(null)}
            onClick={(e) => {
              e.preventDefault();
              if (onOpenWork) onOpenWork(item);
            }}
          >
            <span className="wi2-num">{String(idx + 1).padStart(2, '0')}</span>
            <span className="wi2-thumb">
              <WorkVisual src={item.image} alt={item.label} />
            </span>
            <span className="wi2-strip">
              {strips[idx].map((src, i) => (
                <img key={i} src={src} alt="" className="wi2-strip-img" />
              ))}
            </span>
            <span className="wi2-title">{item.label}</span>
            <span className="wi2-subtitle">{item.subtitle}</span>
          </a>
        ))}
        </div>
      </div>
    </div>
  );
}
